export var setWechatShareInfo = function (options, afterShare) {
    var wx = window.wx;
    try {
        wx.config(options.config);
        var title_1 = options.title, desc_1 = options.desc, url_1 = options.url, thumb_1 = options.thumb;
        wx.ready(function () {
            //朋友圈
            wx.onMenuShareTimeline({
                title: title_1,
                desc: desc_1,
                link: url_1,
                imgUrl: thumb_1,
                success: function () {
                    afterShare({
                        res: 'succ',
                        type: 'WechatMoments'
                    });
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            //分享消息
            wx.onMenuShareAppMessage({
                title: title_1,
                desc: desc_1,
                link: url_1,
                imgUrl: thumb_1,
                type: '',
                dataUrl: '',
                success: function () {
                    afterShare({
                        res: 'succ',
                        type: 'Wechat'
                    });
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            //分享给qq
            wx.onMenuShareQQ({
                title: title_1,
                desc: desc_1,
                link: url_1,
                imgUrl: thumb_1,
                success: function () {
                    afterShare({
                        res: 'succ',
                        type: 'QQ'
                    });
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
            //分享给空间
            wx.onMenuShareQZone({
                title: title_1,
                desc: desc_1,
                link: url_1,
                imgUrl: thumb_1,
                success: function () {
                    afterShare({
                        res: 'succ',
                        type: 'QZone'
                    });
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        });
    }
    catch (e) {
        console.log(e);
    }
};
export var setQQShareInfo = function (options) {
    window.setShareInfo({
        title: options.title,
        summary: options.desc,
        pic: options.thumb,
        url: options.url
    });
    var shareInfo = window.server.share_info || window.server.shareInfo;
    window.$('meta[name="description"]').attr('content', shareInfo.desc);
};
export var hashCode = function (target) {
    if (target instanceof Object) {
        target = JSON.stringify(target);
    }
    var code = 0;
    if (target.length == 0) {
        return code;
    }
    for (var i = 0; i < target.length; i++) {
        var char = target.charCodeAt(i);
        code = (code << 5) - code + char;
        code = code & code;
    }
    return code;
};
export var extend = function (source, target) {
    for (var key in target) {
        if (target.hasOwnProperty(key)) {
            source[key] = target[key];
        }
    }
};
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aiyuke-front-lib/dist/util.js
// module id = null
// module chunks = 